import {
  CANCELACION_SUCCESS,
  CANCELACION_LOADING,
  CANCELACION_ERROR,
  CANCELACION_VALIDACANCELA,
  CANCELACION_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const cancelacionReset = () => (dispatch) => {
  dispatch({
    type: CANCELACION_RESET,
  });
};

// ID PACIENTE FAMILIAR = idPF
export const wsGetValidaCancelacion = (idTurno, idPF) => (dispatch) => {
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/turnos/validaCancelacion/${idTurno}/${!idPF ? "" : idPF}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetValidaCancelacionQr = (idTurno) => (dispatch) => {
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/turnos/validaCancelacionQr/${idTurno}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetValidaCancelacionLabo = (idTurno, idPF) => (dispatch) => {
  axiosInstance(null, "darTurnos").then((respuesta) => {
    respuesta
      .get(`/laboratorio/validaCancelacion/${idTurno}/${!idPF ? "" : idPF}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

// ID PACIENTE FAMILIAR ? idPF
export const wsDeleteTurno =
  (idTurno, idMotivo, motivoOtro, idPF, lugarInicio) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .delete(
          `/turnos/cancelar/${idTurno}/${idMotivo}/${motivoOtro}/${
            !idPF ? "" : idPF
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
            adicional: !lugarInicio ? false : lugarInicio,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsDeleteTurnoQr =
  (idTurno, idMotivo, motivoOtro, lugarInicio) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .delete(`/turnos/cancelarQr/${idTurno}/${idMotivo}/${motivoOtro}`)
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
            adicional: !lugarInicio ? false : lugarInicio,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };

// ID PACIENTE FAMILIAR = idPF
export const wsDeleteTurnolaboratorio =
  (idTurno, idMotivo, otroMotivo, idPF) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `/laboratorio/cancelar/${idTurno}/${idMotivo}/${otroMotivo}/${
            !idPF ? "" : idPF
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsDeleteTurnoSesionKinesio =
  (idSesion, idcanc, motivoOtro, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `/turnos/CancelarSesion/${idSesion}/${idcanc}/${motivoOtro}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };
